export default __webpack_public_path__ + "05db33fe28f6a356f04a445f64c238fb.png";